
import { history, useModel } from '@umijs/max';
import type { MenuProps } from 'antd';
import React from 'react';
import HeaderDropdown from '../HeaderDropdown';

export type GlobalHeaderRightProps = {
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  return <span className="anticon">{currentUser?.mobile}</span>;
};


export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ children }) => {

  const { initialState } = useModel('@@initialState');

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    history.push(key);
  };


  if (!initialState) {
    return '';
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return '';
  }

  // @ts-ignore
  const menuItems = [
    {
      key: '/account/updateAccountPassword',
      label:'修改账号密码',
    },
    {
      key: '/account/updateEvaluateAccountPassword',
      label:'修改评估账号密码',
    },
    {
      key: '/account/reaNameAuthentication',
      label:'实名认证',
    },
    // {
    //   type: 'divider' as const,
    // },
    {
      key: '/account/personal',
      label:'基本信息',
    },
    {
      key: '/account',
      label:'个人中心',
    },
  ];

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      {children}
    </HeaderDropdown>
  );
};
